import React from "react";
import HTMLFlipBook from "react-pageflip";
import PageFlip from "react-pageflip";
import drake1 from '../../assets/drake1.jpg'
import drake2 from '../../assets/drake2.jpg'
import drake3 from '../../assets/drake3.png'
import nick2 from '../../assets/nick2.png'
import './FlipBook.css'
import { Box, ButtonGroup, Button } from "retro-react";
import useIsMobile from "../../hooks/useIsMobile";

class FlipBook extends React.Component{

    constructor(props) {
      super(props);
      this.pageFlip = null; // Initialize to null 
    }
  
    nextButtonClick = () => {
      if (this.pageFlip) {
        this.pageFlip.pageFlip().flipNext(); // Programmatically flip to the next page
      }
    };
  
    prevButtonClick = () => {
      if (this.pageFlip) {
        this.pageFlip.pageFlip().flipPrev(); // Programmatically flip to the previous page
      }
    };

    desktopBook = (mediaLinks) => {      
        return(
          <HTMLFlipBook 
            className="book"
            width={400}
            height={400}
            mobileScrollSupport={true}
            maxShadowOpacity={0}
            startZIndex={100}
            ref={(component) => (this.pageFlip = component)} // Storing the instance in this.pageFlip
          >
            {mediaLinks.map((url, index) => (
              <div key={index}>
                <Box className="demoPage" > 
                  <img className="image-box" src={url}/>
                </Box>
              </div>
            ))}
          </HTMLFlipBook>
        );
      }

    mobileBook = (mediaLinks) =>{
        return(
             <HTMLFlipBook 
                className="book"
                width={340}
                height={400}
                mobileScrollSupport={true}
                maxShadowOpacity={0}
                startZIndex={100}
                ref={(component) => (this.pageFlip = component)} // Storing the instance in this.pageFlip
                >
                {mediaLinks.map((url, index) => (
                <div key={index}>
                  <Box className="demoPage" > 
                    <img className="image-box" src={url}/>
                  </Box>
                </div>
            ))}
            </HTMLFlipBook>
        );
    }

    buttons  = () => {
        return(
        <div className="page-buttons">
            <ButtonGroup className="page-buttons">
                <Button onClick={this.prevButtonClick}>
                    Previous
                </Button>
                <Button onClick={this.nextButtonClick}>
                    Next
                </Button>
            </ButtonGroup>
        </div>
        );
    }
  
    render() {
        const { isMobile, pMediaLinks } = this.props;
        
        return(
          <div className="book-container">
            {isMobile ? this.mobileBook(pMediaLinks) : this.desktopBook(pMediaLinks)} 
            {!isMobile ? <this.buttons/> : <br/>} 
          </div>
        );
      }
}

export default FlipBook;